export const CONSTS = {
  HEADER: $localize`Close Window?`,
  BODY: $localize`Your changes will not be saved.`,
  CONFIRM_TEXT: $localize`Yes`,
  REJECT_TEXT: $localize`No`,
};

export enum BUTTON_CLICK {
  ACCEPT = 'accept',
  REJECT = 'reject',
}
